import { EnvironmentOutlined } from '@ant-design/icons'
import { Checkbox, Empty } from 'antd'
import React, { useRef, useEffect, useState } from 'react'
import AddressItem from './AddressItem'
import Spinner from 'components/Spinner/Spinner'

export default function AddressSection({
    loading, addresses,
    selectedAddresses,
    onAddressesChange,
    primaryAddress,
    onPrimaryAddressChange,
    type
}) {
    const sectionRef = useRef(null)
    // const [maxHeight, setMaxHeight] = useState(null)

    // console.log('maxHeight', maxHeight)

    // useEffect(() => {
    //     // setMaxHeight(null)
    //     // Function to measure and update heights
    //     const updateHeight = () => {
    //         const primaryDiv = document.getElementById('addressSection-primary')
    //         const secondaryDiv = document.getElementById('addressSection-secondary')

    //         console.log('primaryDiv', primaryDiv)
    //         console.log('secondaryDiv', secondaryDiv)

    //         // Only proceed if both divs exist
    //         if (primaryDiv && secondaryDiv) {
    //             const primaryHeight = primaryDiv.scrollHeight
    //             const secondaryHeight = secondaryDiv.scrollHeight

    //             const maxHeightValue = Math.max(primaryHeight, secondaryHeight)


    //             if(primaryHeight < secondaryHeight){
    //                 console.log('first', document.getElementById(`addressSection-primary-parent`))
    //                 document.getElementById(`addressSection-primary-parent`).style.height = maxHeightValue + "px"
    //             }else{
    //                 document.getElementById(`addressSection-secondary-parent`).style.height = maxHeightValue+ "px"
    //             }


    //             // console.log('primaryHeight, secondaryHeight', primaryHeight, secondaryHeight)
    //             // const maxHeightValue = Math.max(primaryHeight, secondaryHeight)
    //             // setMaxHeight(maxHeightValue)
    //         }
    //     }

    //     // Measure after initial render
    //     if (sectionRef.current) {
    //         updateHeight()

    //         // Also measure after a short delay to ensure content is fully rendered
    //         const timeoutId = setTimeout(updateHeight, 5000)

    //         // Set up observer for dynamic content changes
    //         const observer = new ResizeObserver(updateHeight)
    //         observer.observe(sectionRef.current)

    //         return () => {
    //             clearTimeout(timeoutId)
    //             observer.disconnect()
    //         }
    //     }
    // }, [addresses, loading]) // Re-measure when addresses or loading state changes

    const allAddressesChecked = addresses.every(address => {
        return selectedAddresses?.includes(address.addressId)
    })



    return (
        <div
            id={`addressSection-${type}-parent`}
            style={{
                // maxHeight: maxHeight ? `${maxHeight}px` : 'auto',
                // height: maxHeight ? `${maxHeight}px` : 'auto',
                marginBottom: 16,
            }}>
            <div
                ref={sectionRef}
                id={`addressSection-${type}`}
                style={{
                    border: '1px solid #e2e4e9',
                    borderRadius: 6,
                    // height: maxHeight ? `${maxHeight}px` : 'auto',
                    overflow: 'hidden',
                    // height: '100%'
                }}>
                <div
                    style={{
                        borderBottom: '1px solid #e2e4e9',
                        padding: 8,
                        background: '#f0f2f44d',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <div style={{ display: 'flex', gap: 8 }}>
                        <EnvironmentOutlined />
                        <span style={{
                            fontWeight: 600,
                            fontFamily: 'tradeGothic',
                            fontSize: 14
                        }}>
                            Addresses
                        </span>
                    </div>

                    <div style={{ display: 'flex', gap: 8 }}>
                        <Checkbox checked={allAddressesChecked}
                            onChange={e => {
                                if (allAddressesChecked)
                                    onAddressesChange([])
                                else {
                                    const addressIds = addresses.map(address => address.addressId)
                                    onAddressesChange(addressIds)
                                }
                            }}

                        />
                        <span>Select All</span>
                    </div>

                </div>

                {
                    loading && <div style={{
                        display: 'flex', justifyContent: 'center',
                        alignItems: 'center', padding: 8
                    }}> <Spinner /> </div>
                }
                {
                    !addresses.length && loading && <Empty
                        imageStyle={{ height: 32 }}
                        style={{ padding: 12, fontWeight: 500, fontSize: 14 }}
                        description="No Addresses Available"
                    />
                }

                <div style={{
                    padding: 8
                }}>
                    {
                        addresses.map(address => {
                            const isChecked = selectedAddresses.includes(address.addressId)
                            const isPrimary = address.addressId === primaryAddress
                            return <AddressItem
                                key={address.addressId}
                                address={address}
                                isChecked={isChecked}
                                onChange={() => {
                                    console.log('address change', selectedAddresses)
                                    if (isChecked) {
                                        const filteredAddresses = selectedAddresses.filter(selectedAddressesId => selectedAddressesId !== address.addressId)
                                        console.log('filteredAddresses', filteredAddresses)
                                        onAddressesChange(filteredAddresses)
                                    } else {
                                        onAddressesChange([...selectedAddresses, address.addressId])

                                    }
                                }}
                                isPrimary={isPrimary}
                                onPrimaryAddressChange={() => {
                                    console.log('primaryAddressChange')
                                    onPrimaryAddressChange(address.addressId)
                                }}
                            />
                        })
                    }
                    {/* <AddressItem isAddressPrimary={isAddressPrimary} lastItem={isAddressPrimary === false} />
                {
                    isAddressPrimary === true && <AddressItem isAddressPrimary={false} lastItem={true} />
                } */}

                </div>
            </div>
        </div>
    )
}
